import React from 'react';
import { Link } from 'gatsby';

import '../../styles/scss/style.scss';


export const Hero3 = () => {
  return (
          <div className="hero" style={{ marginTop:"10rem" }}>
            <div className="feature__wrap">
        <div className="feature__left animated fadeInLeft">
                <h3 className="feature__lead feature__lead--1 showcase__lead text-left">
                  Dark Mode
                </h3>
                <p className="feature__text">
                    Loop Pro X  comes with light and dark mode for all the components, predesigned pages 
                    and templates to give you more choices on how you want your designs to look
                </p>
          <br />

                    {/* <Link
                      className="btn1 btn__inverse"
                      to="/app/downloads"
                    >
                       Get Loop
                    </Link> */}
              </div>
        <div className="feature__right animated fadeInRight">
                <img
                  src={require('../../components/images/loopdarkmode.png')}
                  alt="#"
                  className="feature__img"
                  
                />
              </div>
            </div>

          </div>
  );
};
